import { render, staticRenderFns } from "./SRTitleListGraphql.vue?vue&type=template&id=7964d20a&scoped=true"
import script from "./SRTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./SRTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SRTitleListGraphql.vue?vue&type=style&index=0&id=7964d20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7964d20a",
  null
  
)

export default component.exports